import { useMutation } from "@tanstack/react-query";

import { postTeacherIntervention } from "./InterventionApi";

export const usePostTeacherIntervention = () =>
  useMutation({
    mutationFn: (body) => postTeacherIntervention(body),
  });
